import { handleActions } from 'redux-actions';
import { setSeatMap } from './actions';
const initialState = {
    segments: []
};
const seatMapReducer = handleActions({
    [setSeatMap.toString()]: (_, { payload }) => payload
}, initialState);
export default seatMapReducer;
